// @flow
import { all } from "redux-saga/effects";

function* MenuSaga() {
	yield all([
	]);
}

export default MenuSaga;